import type { AnimationVariant } from '@game-platform/pack-animation';

export interface Mechanic {
  variant: AnimationVariant;
  title: string;
  description: string;
}

export const MECHANICS: readonly Mechanic[] = [
  {
    variant: 'slot',
    title: 'Slot Lane',
    description: 'Spin the lane, hit RIP!, glow and rays reveal the card.',
  },
  {
    variant: 'slice',
    title: 'Slice',
    description: 'The player cuts the seal with a finger; the lid tears off and the card slides out.',
  },
  {
    variant: 'burst',
    title: 'Burst',
    description:
      'The player holds the pack until it bursts into shards; the card assembles from the pieces.',
  },
  {
    variant: 'carousel',
    title: 'Carousel',
    description:
      'Copies of the pack turn on a stage; the player picks one, its facts and tier are told, then the card flips over.',
  },
];

export function mechanicTitle(variant: AnimationVariant): string {
  return MECHANICS.find((m) => m.variant === variant)?.title ?? variant;
}
